'use client';

import { c as _c } from "react/compiler-runtime";
import { Link } from '@components/link';
import { Typography } from '@components/typography';
import dynamic from 'next/dynamic';
import { signIn } from '@lib/auth/client';
import { useState, useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { useScript, appleAuthHelpers } from 'react-apple-signin-auth';
import { routes } from '@routes';
import { useToggle } from '@hooks';
import { setReferralCode } from '@utils/referral-code';
import { Button } from '@components/button';
import { Form as StaticForm } from './form';
import { SocialLogin, SocialLoginType } from '@components/social-login';
import { Spinner } from '@components/spinner';
import { ReferralCodeInput } from '@components/referral-code-input';
const Form = dynamic<React.ComponentProps<typeof StaticForm>>(() => import('./form').then(mod => mod.Form), {
  loading: () => <Spinner className="mx-auto my-8" />
});
type SignupProps = {
  referralCode?: string | null;
  redirectUrl?: string;
};
export const Signup: React.FC<SignupProps> = t0 => {
  const $ = _c(49);
  const {
    referralCode: propReferralCode,
    redirectUrl
  } = t0;
  const searchParams = useSearchParams();
  useScript(appleAuthHelpers.APPLE_SCRIPT_SRC);
  const {
    on,
    setOn
  } = useToggle(false);
  let t1;
  if ($[0] !== searchParams) {
    t1 = searchParams?.get("ref") || undefined;
    $[0] = searchParams;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const urlReferralCode = t1;
  const initialReferralCode = propReferralCode || urlReferralCode || "";
  const [referralCode, setReferralCodeState] = useState(initialReferralCode);
  let t2;
  let t3;
  if ($[2] !== referralCode) {
    t2 = () => {
      if (referralCode) {
        setReferralCode(undefined, referralCode);
      }
    };
    t3 = [referralCode];
    $[2] = referralCode;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] !== setOn) {
    t4 = () => {
      setOn();
    };
    $[5] = setOn;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleEmailClick = t4;
  let t5;
  if ($[7] !== redirectUrl || $[8] !== referralCode) {
    t5 = provider => {
      const callbackUrl = referralCode ? `${routes.userAccountSettings}#your-rewards` : redirectUrl;
      signIn(provider, callbackUrl ? {
        callbackUrl
      } : undefined);
    };
    $[7] = redirectUrl;
    $[8] = referralCode;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  const handleSocialLogin = t5;
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = code => {
      setReferralCodeState(code);
    };
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  const handleReferralCodeChange = t6;
  let t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <Typography component="h1" variant="title2" variantM="title1">Stay Smarter.</Typography>;
    t8 = <Typography component="p" variant="body1" className="text-primary-main/70">Join the Savvy community where everyone wins. Whether you're a traveler ready to book your next getaway (and save hundreds) or a host ready to list your properties, you're in the right place.</Typography>;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <div className="sm:mx-auto sm:w-full text-center flex flex-col"><div className="text-center space-y-3 pb-8 max-w-xl mx-auto">{t7}{t8}<div className="flex justify-center pt-2"><Link to={routes.login} className="text-sm font-semibold text-primary-main underline underline-offset-2 hover:text-secondary-main transition-colors">Already have an account? Log in</Link></div></div></div>;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const t10 = `w-full transition-opacity duration-300 ${on ? "absolute inset-x-0 top-0 opacity-0" : "opacity-100"}`;
  const t11 = on ? "hidden" : "visible";
  let t12;
  if ($[14] !== t11) {
    t12 = {
      visibility: t11
    };
    $[14] = t11;
    $[15] = t12;
  } else {
    t12 = $[15];
  }
  let t13;
  if ($[16] !== handleSocialLogin) {
    t13 = <SocialLogin social={SocialLoginType.Google} onClick={() => handleSocialLogin("google")} />;
    $[16] = handleSocialLogin;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="absolute inset-0 flex items-center"><div className="w-full border-t border-gray-400" /></div>;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="relative w-full py-2">{t14}<div className="relative flex justify-center"><Typography component="span" variant="body2" className="bg-white px-4 text-primary-main/50 text-sm">or</Typography></div></div>;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <p className="py-1">Continue with Email</p>;
    $[20] = t16;
  } else {
    t16 = $[20];
  }
  let t17;
  if ($[21] !== handleEmailClick) {
    t17 = <Button variant="outlined" onClick={handleEmailClick} aria-describedby="Email Sign-up" className="justify-center w-full active:scale-95 active:bg-gray-xlight hover:bg-gray-xlight bg-white">{t16}</Button>;
    $[21] = handleEmailClick;
    $[22] = t17;
  } else {
    t17 = $[22];
  }
  let t18;
  if ($[23] !== t13 || $[24] !== t17) {
    t18 = <div className="flex flex-col space-y-4 items-center w-full">{t13}{t15}{t17}</div>;
    $[23] = t13;
    $[24] = t17;
    $[25] = t18;
  } else {
    t18 = $[25];
  }
  let t19;
  if ($[26] !== t10 || $[27] !== t12 || $[28] !== t18) {
    t19 = <div className={t10} style={t12}>{t18}</div>;
    $[26] = t10;
    $[27] = t12;
    $[28] = t18;
    $[29] = t19;
  } else {
    t19 = $[29];
  }
  const t20 = `w-full transition-opacity duration-300 ${on ? "opacity-100" : "absolute inset-x-0 top-0 opacity-0"}`;
  const t21 = !on ? "hidden" : "visible";
  let t22;
  if ($[30] !== t21) {
    t22 = {
      visibility: t21
    };
    $[30] = t21;
    $[31] = t22;
  } else {
    t22 = $[31];
  }
  let t23;
  if ($[32] !== redirectUrl || $[33] !== referralCode) {
    t23 = <div className="flex flex-col space-y-4 items-center w-full"><Form referralCode={referralCode} redirectUrl={redirectUrl} /></div>;
    $[32] = redirectUrl;
    $[33] = referralCode;
    $[34] = t23;
  } else {
    t23 = $[34];
  }
  let t24;
  if ($[35] !== t20 || $[36] !== t22 || $[37] !== t23) {
    t24 = <div className={t20} style={t22}>{t23}</div>;
    $[35] = t20;
    $[36] = t22;
    $[37] = t23;
    $[38] = t24;
  } else {
    t24 = $[38];
  }
  let t25;
  if ($[39] !== t19 || $[40] !== t24) {
    t25 = <div className="relative w-full">{t19}{t24}</div>;
    $[39] = t19;
    $[40] = t24;
    $[41] = t25;
  } else {
    t25 = $[41];
  }
  const t26 = propReferralCode || urlReferralCode;
  let t27;
  if ($[42] !== t26) {
    t27 = <ReferralCodeInput initialCode={t26} onCodeChange={handleReferralCodeChange} className="mt-6 w-full" />;
    $[42] = t26;
    $[43] = t27;
  } else {
    t27 = $[43];
  }
  let t28;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t28 = <Link tabIndex={-1} to={routes.terms} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-primary-main transition-colors">{"Terms & Conditions"}</Link>;
    $[44] = t28;
  } else {
    t28 = $[44];
  }
  let t29;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <Typography component="p" className="mt-6 text-xs text-center text-primary-main/60 leading-relaxed">By signing up, I agree to Savvy's{" "}{t28}{" "}and acknowledge the{" "}<Link tabIndex={-1} to={routes.privacy} target="_blank" rel="noopener noreferrer" className="underline underline-offset-2 hover:text-primary-main transition-colors">Privacy Policy</Link>.</Typography>;
    $[45] = t29;
  } else {
    t29 = $[45];
  }
  let t30;
  if ($[46] !== t25 || $[47] !== t27) {
    t30 = <div className="flex flex-col justify-center items-center pt-6 pb-8 sm:pt-4 text-primary-main"><div className="body-container">{t9}<div className="flex flex-col max-w-lg items-center md:px-14 mx-auto w-full">{t25}{t27}{t29}</div></div></div>;
    $[46] = t25;
    $[47] = t27;
    $[48] = t30;
  } else {
    t30 = $[48];
  }
  return t30;
};